import { useState, type FormEventHandler } from 'react';
import { Icon } from './Icon';

interface Props {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  autoComplete?: string;
  id?: string;
  name?: string;
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  onInvalid?: FormEventHandler<HTMLInputElement>;
  onInput?: FormEventHandler<HTMLInputElement>;
}

/** Поле пароля/секрета с кнопкой «показать/скрыть» (глаз). */
export function PasswordInput({
  value,
  onChange,
  placeholder,
  autoComplete,
  id,
  name,
  required,
  disabled,
  autoFocus,
  onInvalid,
  onInput,
}: Props) {
  const [show, setShow] = useState(false);
  return (
    <div className="pwd-wrap">
      <input
        id={id}
        name={name}
        className="input"
        type={show ? 'text' : 'password'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
        disabled={disabled}
        autoFocus={autoFocus}
        onInvalid={onInvalid}
        onInput={onInput}
      />
      <button
        type="button"
        className="pwd-eye"
        aria-label={show ? 'Скрыть' : 'Показать'}
        aria-pressed={show}
        tabIndex={-1}
        disabled={disabled}
        onClick={() => setShow((s) => !s)}
      >
        <Icon name={show ? 'EyeOff' : 'Eye'} />
      </button>
    </div>
  );
}
